import { Reducer } from 'redux';
import { CampaignsAction } from './actions';
import { CampaignsState } from './types';

const initialState: CampaignsState = {};

const reducer: Reducer<
  CampaignsState,
  CampaignsAction
> = function campaignsReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_CAMPAIGNS_CONFIG':
      return {
        ...state,
        config: {},
      };

    case 'GET_CAMPAIGNS_CONFIG_SUCCESS':
      return {
        ...state,
        config: action.payload,
      };

    case 'SET_CAMPAIGN_START':
      return {
        ...state,
        inCreation: {
          ...state.inCreation,
          startAt: action.startAt,
        },
      };

    case 'SET_CAMPAIGN_END':
      return {
        ...state,
        inCreation: {
          ...state.inCreation,
          endAt: action.endAt,
        },
      };

    case 'SET_CAMPAIGN_RESTAURANTS':
      return {
        ...state,
        inCreation: {
          ...state.inCreation,
          restaurantIds: action.restaurantIds,
        },
      };

    case 'SET_CAMPAIGN_VALIDATION':
      return {
        ...state,
        inCreation: {
          ...state.inCreation,
          isValidating: action.validate,
        },
      };

    default:
      return state;
  }
};

export default reducer;
